import React, {useMemo} from "react";
import {Card, CardActions, CardContent} from "@mui/material";
import {CardData, CardTitle} from "@atttomyx/react-components";
import {formatters, money} from "@atttomyx/shared-utils";

const TaxCard = (props) => {
    const {year, offerings, filters, children} = props;

    const summary = useMemo(() => {
        const monies = offerings.map(offering => offering.amount);

        return {
            year: year,
            total: money.add(monies),
        }
    }, [year, offerings]);

    return <Card className="tax-card" raised={true}>
        <CardContent>
            <CardTitle>
                Tax Statement
            </CardTitle>
            <CardData
                filters={filters}
                data={summary}
                keyToMetadata={{
                    total: {
                        title: "Total",
                        formatter: formatters.usDollars,
                    },
                    year: {
                        title: "Year",
                    },
                }}
            />
        </CardContent>
        <CardActions disableSpacing={true}>
            {children}
        </CardActions>
    </Card>
}

export default TaxCard;
